import config from "../config/config";
import { getToken } from "../utils/prefix";

// export async function tesk_createAPI(data) {
//   const res = await fetch(config.api_backend + `/task/create`, {
//     body: JSON.stringify(data),
//     method: "POST",
//     headers: {
//     "x-access-token": getToken(),
//       "Content-type": "application/json",
//     },
//   });

//   const dataRespone = await res.json();
//   return dataRespone;
// }
export async function task_create(data) {
  const res = await fetch(config.api_backend + `/task/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function task_update(data) {
  const res = await fetch(config.api_backend + `/task/update`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function task_delete(data) {
  const res = await fetch(config.api_backend + `/task/delete`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function task_drop(data) {
  const res = await fetch(config.api_backend + `/task/drop`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task(data) {
  const res = await fetch(config.api_backend + `/task/getById`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_id(data) {
  const res = await fetch(config.api_backend + `/task/getid`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_dataset_download(data) {
  const res = await fetch(config.api_backend + `/task/dataset/download/save`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_dataset_count(data) {
  const res = await fetch(config.api_backend + `/task/dataset/download/get`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_original_transcribe(data) {
  const res = await fetch(config.api_backend + `/task/getTranscribe`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_admin_task(data) {
  const res = await fetch(config.api_backend + `/task/admin`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_subtitle(data) {
  const res = await fetch(config.api_backend + `/task/getTranscribe`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_transcribe(data) {
  const res = await fetch(config.api_backend + `/task/getMaskResult`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_all_task(data) {
  const res = await fetch(config.api_backend + `/task/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_check_task(data) {
  const res = await fetch(config.api_backend + `/task/checkid`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_by_id(data) {
  const res = await fetch(config.api_backend + `/task/getById`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_filter_task(data) {
  const res = await fetch(config.api_backend + `/task/getTask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_task_status(data) {
  const res = await fetch(config.api_backend + `/task/updateTaskStatus`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_task_files(project_id, data, task_name) {
  var formdata = new FormData();
  formdata.append("file", data);
  formdata.append("task_name", task_name);
  formdata.append("project_id", project_id);

  const res = await fetch(config.api_backend + `/task/uploadTaskFile`, {
    body: formdata,
    method: "POST",
    headers: {
      // Authorization: getToken(),
      // "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function test_masking(data) {
  const res = await fetch(config.api_dialog + `/masking`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "x-access-token": config.dialog_token,
      "Content-type": "application/json",
      mode: "test",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function test_analyze(data) {
  const res = await fetch(config.api_dialog + `/analyze`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "x-access-token": config.dialog_token,
      "Content-type": "application/json",
      mode: "test",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_task_answer(data) {
  const res = await fetch(config.api_backend + `/task/saveAnswerJson`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_transcribe(data) {
  const res = await fetch(config.api_backend + `/task/saveTranscribe`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_original_transcribe(data) {
  const res = await fetch(config.api_backend + `/task/saveOriginalTranscribe`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_active(data) {
  const res = await fetch(config.api_backend + `/task/get`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_task_answer(data) {
  const res = await fetch(config.api_backend + `/task/getAnswerJson`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function findTask(data) {
  const res = await fetch(config.api_backend + `/task/findTask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function evaluate_task(data) {
  const res = await fetch(config.api_dialog + `/evaluate`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "x-access-token": config.dialog_token,
      "Content-type": "application/json",
      mode: "test",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function update_task_acc(data) {
  const res = await fetch(config.api_backend + `/task/updateTaskAcc`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "x-access-token": config.dialog_token,
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function findStatusTask(data) {
  const res = await fetch(config.api_backend + `/task/findStatusTask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function updateDateTask(data) {
  const res = await fetch(config.api_backend + `/task/updateDateTask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "x-access-token": config.dialog_token,
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function filterTaskByDate(data) {
  const res = await fetch(config.api_backend + `/task/filterTaskByDate`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_graph_pie(data) {
  const res = await fetch(config.api_backend + `/task/getGraphData`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_graph(data) {
  const res = await fetch(config.api_backend + `/task/getGraphData`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_graph_daily(data) {
  const res = await fetch(config.api_backend + `/task/getGraphDataDaily`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_graph_monthly(data) {
  const res = await fetch(config.api_backend + `/task/getGraphDataMonth`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function text_tran(data) {
  const res = await fetch(config.api_texttran + `/text/transform/string`, {
    body: data,
    method: "POST",
    headers: {
      Authorization:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmciOiJhaTkiLCJzZXJ2aWNlIjoic3lzdGVtIiwiaWF0IjoxNjAwMDkxMjUxLCJleHAiOjQxMzE2MjcyNTF9.ZrODaGffnS1u10wCjIYbXV-2sCfT6BkN4hgZxOMgiJo",
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_graph_data(data) {
  const res = await fetch(config.api_backend + `/task/saveGraphData`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function update_graph_data(data) {
  const res = await fetch(config.api_backend + `/task/updateGraphData`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_graph_record(data) {
  const res = await fetch(config.api_backend + `/task/getGraphRecord`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getExportTaskSubmission(data) {
  const res = await fetch(config.api_backend + `/task/exporttasksubmis`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getExportDashboard(data) {
  const res = await fetch(
    config.api_backend + `/task/export/dashbord/summary`,
    {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        //   Authorization: getToken(),
        "Content-type": "application/json",
      },
    },
  );

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getExportDashboardTask(data) {
  const res = await fetch(config.api_backend + `/task/export/dashbord/task`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getDashboardTaskTop5(data) {
  const res = await fetch(config.api_backend + `/task/dashbord/top5/task`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
export async function getDashboardDatasetTop5(data) {
  const res = await fetch(config.api_backend + `/task/dashbord/top5/dataset`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getDashboardTaskAll(data) {
  const res = await fetch(config.api_backend + `/task/dashbord/all/task`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}
export async function getDashboardDatasetAll(data) {
  const res = await fetch(config.api_backend + `/task/dashbord/all/dataset`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getDashboardPerformance(data) {
  const res = await fetch(
    config.api_backend + `/task/dashbord/export/performance`,
    {
      body: JSON.stringify(data),
      method: "POST",
      headers: {
        //   Authorization: getToken(),
        "Content-type": "application/json",
      },
    },
  );

  const dataRespone = await res.json();
  return dataRespone;
}

export async function getDashboardData(data) {
  const res = await fetch(config.api_backend + `/task/dashbord/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function toggleSubmissionStatus(data) {
  const res = await fetch(config.api_backend + `/task/toggleSubmissionStatus`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

export async function taskClearResources(data) {
  const res = await fetch(config.api_backend + `/task/clearresource`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}
